
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    CAPTOREPORT_ACTION,
    ALL_CAPTOREPORT,
    ADD_CAPTOREPORT,
    DELETE_CAPTOREPORT,
    FETCH_CAPTOREPORT,
    EDIT_CAPTOREPORT,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * CAPTO PUTTING REPORT Actions
 */

    export const allCaptoReport = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: CAPTOREPORT_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqcaptoreport', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_CAPTOREPORT, payload: alldata });
            });
        }        
    
    }

    export const addCaptoReport = (data, selfile) =>{
        var totput=data.target.totputt.value;

        var payload={
            "student":data.target.student.value,
            "date":data.target.seldate.value,
            "fileupl":selfile,
            "reportname":data.target.reportname.value,
            "totput":data.target.totputt.value
        }

        for (let i = 1; i<=totput; i++) {        
        
            var sepday='lesson_'+i;            
            var sedyval=data.target[sepday].value;
            var sepopt='obervat_'+i;            
            var seoptval=data.target[sepopt].value;

            payload[sepday]=sedyval;
            payload[sepopt]=seoptval;
    
        }
        return (dispatch) => { 
            dispatch({ type:CAPTOREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/uploadtqcaptoreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allCaptoReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_CAPTOREPORT});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    } 
    
    export const fetchCaptoReport = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:CAPTOREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtqcaptoreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_CAPTOREPORT, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteCaptoReport = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:CAPTOREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqcaptoreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allCaptoReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_CAPTOREPORT});                    
                }                
                
            });
        
        }
    }


    export const editCaptoReport = (formData) => {
        const payload = formData;
        return async (dispatch) => {
            dispatch({ type: CAPTOREPORT_ACTION });
    
            try {
                const response = await axios.post(AppConfig.apiurl + '/api/edittqcaptoreport', payload, {
                    headers: AuthHeader.header,
                });
                const resdata = response.data;
                if (resdata.status === 1) {
                    await allCaptoReport()(dispatch);
                    NotificationManager.success(resdata.message);
                    const { particularcaptoreport } = store.getState().captoreport;
                    dispatch({ type: EDIT_CAPTOREPORT, payload: particularcaptoreport });
                }
                return Promise.resolve(resdata);
            } catch (error) {
                console.error('Error during editCaptoReport:', error);
                return Promise.reject(error);
            }
        };
    };
    
    
      
    
    
   

